//Discontinued use of date picker until its been "cooked" a little longer

//This is an implmentation of NgbDateParserFormatter that overrides the formatting/parse
//functions to allow for properly formatted outputs.  Unfortunately, at the time of this
//writing, there is no other way to change how the control formats its date values in
//the input box for: NgbInputDatepicker

//Genral Links
//https://ng-bootstrap.github.io/#/components/datepicker
//https://github.com/ng-bootstrap/ng-bootstrap/issues/754
//https://github.com/ng-bootstrap/ng-bootstrap/blob/64eca2d4df317ce211e32f8e5357dc6df0d02b2c/src/datepicker/ngb-date-parser-formatter.ts#L4-L7

//An example implementation:
//https://gist.github.com/nrobinaubertin/61ff1c3db355c74f4e56f485b566ab22

// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from "@angular/core";

//Bootstrap
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

import moment from 'moment';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// casNgbDateParserFormatter
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Injectable()
export class casNgbDateParserFormatter extends NgbDateParserFormatter {

    // PUBLIC OVERRIDES
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // format
    //==================================
    //format(date: NgbDateStruct): string {
    format(date) {
        let stringDate = ""; 

        if(date) {
            try{
                stringDate += isNumber(date.month) ? date.month + "/" : "";
                stringDate += isNumber(date.day) ? date.day + "/" : "";
                stringDate += date.year || "";
            }
            catch(ex){
                return "";
            }
        }

        return stringDate;
    }

    //==================================
    // parse
    //==================================
    //parse(value: string): NgbDateStruct {
    parse(value){
        
        //In some UIs,  this fires everytime the user types, but so far it doesn't seem to have any negative impact 
        //(it just comes up with a lot of "dates" before they finish)

        //Attempt a strict parsing (for direct user input)
        //We do this because generous formatting changes the date in the input and can not only be
        //confusing, but can trigger "angular check" errors
        let m = moment(value, "M/D/YYYY", true);

        //If that doesn't work, try an iso8601 format (this is what comes back from .NET for DB data)
        if (!m.isValid()){
            m = moment(value, moment.ISO_8601);
        }

        if (m.isValid()){
            return { 
                year:m.year(), 
                month:m.month()+1, 
                day:m.date()
            };
        }
        else{
            return null;
        }
    }

    // PUBLIC METHODS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // dateStringToNgbDateStruct
    //==================================
    // Converts a date string to a nbgDateStruct, using moment
    dateStringToNgbDateStruct(dateString){

        //This is the same thing as the parse override, but I wanted a more explict method name for my calls.
        return this.parse(dateString);
    };

    //==================================
    // ngbDateStructToDate
    //==================================
    // Converts the nbgDateStruct to a javascript date
    ngbDateStructToDate(ngbDateStruct){

        if (ngbDateStruct){
            return new Date(ngbDateStruct.year, ngbDateStruct.month-1, ngbDateStruct.day);
        }
        else{
            return null;
        }
    }

    //==================================
    // ngbDateStructToDateString
    //==================================
    // Converts the nbgDateStruct to a date string (same as format, but more explicitly named) 
    ngbDateStructToDateString(ngbDateStruct){
        return this.format(ngbDateStruct);
    }

    //==================================
    // dateToNgbDateStruct
    //==================================
    // Converts the javascript date to a nbgDateStruct
    dateToNgbDateStruct(jsDate){

        if (jsDate){
            return {
                year:jsDate.getFullYear(),
                month:jsDate.getMonth()+1,
                day:jsDate.getDate()
            };
        }
        else{
            return null;
        }
    }

}


    // HELPERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // isNumber
    //==================================
    function isNumber(value){
        return !isNaN(value);
    }

